import EventMonthTable from './EventMonthTable';
import { startOfWeekWithFirstDay } from '../../date/DateHelpers';
import DateFormatter from '../../date/EventListingDateFormatter';
import RangeFormatter from '../../date/EventListingRangeFormatter';
import { Days } from '../generateCalendarWeeks';

class EventWeekTable extends EventMonthTable {

  constructor(firstDayOfWeek = Days.Sunday) {
    super(firstDayOfWeek);
    this.resultsFormatter = RangeFormatter.weekRange;
    this.thFormatter = DateFormatter.weekdayDate;
    this.firstDayOfWeek = firstDayOfWeek;
  }

  getWeeksStructure(date) {
    const weeks = super.getWeeksStructure(date);
    const dateTime = startOfWeekWithFirstDay(date, this.firstDayOfWeek).getTime();

    return weeks.filter(week => startOfWeekWithFirstDay(week[0].date, this.firstDayOfWeek).getTime() === dateTime);
  }
}

export default EventWeekTable;
